import { ApartmentDetails } from "../../../../types/apartments";

/**
 * Which photos a room shows, in display order — one definition shared by the
 * detail galleries and the summary thumbnail.
 *
 * The featured image lives on the Group and fronts the result list; the
 * detail response exposed only the asset's `additionalImages`, so a room
 * whose only photo was its featured image showed a photo in the list and
 * "No images" on its own detail page.
 */
export const roomGalleryImages = (
  details?: ApartmentDetails | null
): string[] => {
  const featured = details?.Group?.featuredImage;
  // Array.isArray, not ?? [] — migrated JSON columns can arrive as {} (see
  // the pricing_discounts artifact), which a nullish fallback would pass on.
  const additional = Array.isArray(details?.additionalImages)
    ? (details?.additionalImages as string[])
    : [];
  return Array.from(
    new Set(
      [featured, ...additional].filter((src): src is string => Boolean(src))
    )
  );
};
